<div class='AssociatedProductsListingMobileRow mobile-row row '>
  <div class='LAssociatedProductsListingMobileRow--left mobile-row-section col col-5'>{{ item.name }}</div>
  <div class='LAssociatedProductsListingMobileRow--left mobile-row-section col col-5'>{{ item.current_status }}</div>
  <div class='LAssociatedProductsListingMobileRow--right mobile-row-section col col-2'>
    <app-menu-button [properties]='menuItems'
                     [target]='item'></app-menu-button>
  </div>
</div>
